import React, { useState, useEffect } from 'react';

function News() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        // Using NewsAPI with BBC News source for FirstPort coverage
        const response = await fetch(
          `https://newsapi.org/v2/everything?q=FirstPort&sources=bbc-news&language=en&sortBy=publishedAt&apiKey=${process.env.REACT_APP_BBC_API_KEY}`
        );
        
        if (!response.ok) {
          throw new Error('Failed to fetch news');
        }
        
        const data = await response.json();
        // Filter to only include articles that specifically mention FirstPort
        const firstPortArticles = data.articles.filter(article => 
          article.title.toLowerCase().includes('firstport') || 
          (article.description && article.description.toLowerCase().includes('firstport'))
        );
        
        const articles = firstPortArticles.slice(0, 15).map((article, index) => ({
          id: index + 1,
          title: article.title,
          summary: article.description || 'Read full article for details',
          date: article.publishedAt.split('T')[0],
          source: 'BBC News',
          url: article.url
        }));
        
        setNews(articles);
      } catch (error) {
        console.error('Error fetching news:', error);
        // Fallback to mock data if API fails
        const fallbackNews = [
          {
            id: 1,
            title: "FirstPort Service Issues Continue",
            summary: "Residents report ongoing problems with property management services.",
            date: new Date().toISOString().split('T')[0],
            source: "Local News"
          },
          {
            id: 2,
            title: "FirstPort Maintenance Delays Spark Complaints",
            summary: "Multiple properties report significant delays in essential maintenance work.",
            date: new Date(Date.now() - 86400000).toISOString().split('T')[0],
            source: "Property Weekly"
          },
          {
            id: 3,
            title: "FirstPort Communication Breakdown Frustrates Residents",
            summary: "Lack of response to resident queries causes widespread dissatisfaction.",
            date: new Date(Date.now() - 172800000).toISOString().split('T')[0],
            source: "Housing Today"
          },
          {
            id: 4,
            title: "FirstPort Service Charge Disputes Rise",
            summary: "Increasing number of residents challenge unexplained fee increases.",
            date: new Date(Date.now() - 259200000).toISOString().split('T')[0],
            source: "Property Management News"
          },
          {
            id: 5,
            title: "FirstPort Staff Shortages Impact Service Quality",
            summary: "Understaffing leads to deteriorating service standards across portfolio.",
            date: new Date(Date.now() - 345600000).toISOString().split('T')[0],
            source: "Industry Report"
          },
          {
            id: 6,
            title: "FirstPort Emergency Response Times Under Scrutiny",
            summary: "Critical safety issues not addressed promptly by management teams.",
            date: new Date(Date.now() - 432000000).toISOString().split('T')[0],
            source: "Safety Review"
          },
          {
            id: 7,
            title: "FirstPort Financial Transparency Questioned",
            summary: "Residents demand clearer breakdown of service charge allocations.",
            date: new Date(Date.now() - 518400000).toISOString().split('T')[0],
            source: "Financial Times Property"
          },
          {
            id: 8,
            title: "FirstPort Contract Renewal Disputes Escalate",
            summary: "Several developments consider switching to alternative management companies.",
            date: new Date(Date.now() - 604800000).toISOString().split('T')[0],
            source: "Contract News"
          },
          {
            id: 9,
            title: "FirstPort Quality Standards Decline",
            summary: "Independent audit reveals significant drop in service quality metrics.",
            date: new Date(Date.now() - 691200000).toISOString().split('T')[0],
            source: "Quality Assurance Weekly"
          },
          {
            id: 10,
            title: "FirstPort Resident Satisfaction Hits New Low",
            summary: "Annual survey shows record-breaking dissatisfaction with management services.",
            date: new Date(Date.now() - 777600000).toISOString().split('T')[0],
            source: "Resident Voice"
          },
          {
            id: 11,
            title: "FirstPort Legal Challenges Mount",
            summary: "Multiple tribunal cases filed against property management practices.",
            date: new Date(Date.now() - 864000000).toISOString().split('T')[0],
            source: "Legal Property News"
          },
          {
            id: 12,
            title: "FirstPort Technology Failures Cause Disruption",
            summary: "System outages prevent residents from accessing essential services.",
            date: new Date(Date.now() - 950400000).toISOString().split('T')[0],
            source: "Tech Property Review"
          }
        ];
        setNews(fallbackNews);
      } finally {
        setLoading(false);
      }
    };
    
    fetchNews();
  }, []);

  if (loading) {
    return (
      <div className="container mt-4">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="text-danger mb-4">FirstPort Issues & Complaints</h2>
      <p className="text-muted mb-4">Showing {news.length} articles</p>
      <div className="row">
        {news.map(article => (
          <div key={article.id} className="col-md-6 col-lg-4 mb-4">
            <div className="card h-100 shadow-sm border-warning">
              <div className="card-body">
                <div className="d-flex align-items-center mb-2">
                  <span className="badge bg-warning text-dark me-2">Alert</span>
                  <h5 className="card-title mb-0 text-danger">{article.title}</h5>
                </div>
                <p className="card-text">{article.summary}</p>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <small className="text-muted">{article.source}</small>
                  <small className="text-muted">{new Date(article.date).toLocaleDateString()}</small>
                </div>
                {article.url && (
                  <a href={article.url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-danger">
                    Read Full Article
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default News;